/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./VendorTable.scss";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { getValue} from "@utils/lodash";
import CreateModal from "@pages/Checkpoint/ReleaseDatesNew/Accordian/CreateModal/CreateModal";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { QueryRequestHelper } from "@_common/query-request-helper";
import {
  GetCheckpointReleaseDateVendorLocation,
  ReleaseVendorAuditCompleteBulkUpload,
} from "@services/checkpoint.service";
import {
  convertCurrentDate,
} from "@_common/date-helpers";
import PaginationPage from "@components/pagination/pagination";
import { useNavigate } from "react-router-dom";
import Loader from "@components/common/Loader";
import { toast } from "react-toastify";
import ConfirmModal from "@_common/ConfirmModal";
import ReleaseCustomNavigationBar from "@components/ReleaseCustomNotificationBar";

// function VendorTable(props: object) {
export default function VendorTable(props: any) {
  const [list, setList] = React.useState<[]>([]);
  const [listAuditComplete, setListAuditComplete] = React.useState<[]>([]);
  const [date, setDate] = useState<Date | null>(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  /*---------------------------USE Effect----------------------------- */
  // useEffect(() => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   if (props.vendorId) {
  //     getData(page_no, limit);
  //   }
  // }, [props.permissionAPITriggered, props.vendorId]);

  useEffect(() => {
    if (props.vendorId) {
      getData(page_no, limit);
    }
  }, [window.location.href, props.permissionAPITriggered, props.vendorId]);

  const getData = async (page_no: number, limit: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      vendor_id: getValue(props, `vendorId`, ""),
      region_id: getValue(props, `region_id`, ""),
      group_id: getValue(props, `group_id`, ""),
      page_no: page_no,
      page_size: limit,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await GetCheckpointReleaseDateVendorLocation(queryRequest);
      if (resp) {
        setListAuditComplete(getValue(resp, `data.vendorReleaseDate`, {}));
        setList(
          getValue(resp, `data.vendorReleaseDate.locations`, []).map(
            (item: object) => ({
              ...item,
              vendor_id: getValue(resp, `data.vendorReleaseDate.id`, ""),
              created_at: convertCurrentDate(getValue(item, `created_at`, "")),
              group_name: getValue(item, `group.group_name`, ""),
              // recent_release_dates: convertCurrentDate(getValue(item,`release_date_location.release_date_audit_cycles.start_date`,"")) + " to " + convertCurrentDate(getValue(item,`release_date_location.release_date_audit_cycles.cutoff_date`,"")),
              recent_release_dates:
                getValue(
                  item,
                  `release_date_location.release_date_audit_cycles.start_date`,
                  ""
                ) ||
                getValue(
                  item,
                  `release_date_location.release_date_audit_cycles.cutoff_date`,
                  ""
                )
                  ? convertCurrentDate(
                      getValue(
                        item,
                        `release_date_location.release_date_audit_cycles.start_date`,
                        ""
                      )
                    ) +
                    " to " +
                    convertCurrentDate(
                      getValue(
                        item,
                        `release_date_location.release_date_audit_cycles.cutoff_date`,
                        ""
                      )
                    )
                  : "-",
              // release_cycle: "Release" + getValue(item, `release_date_location.release_date_audit_cycles.cycle`, "")
              release_cycle: getValue(
                item,
                `release_date_location.release_date_audit_cycles.cycle`,
                ""
              )
                ? "Release " +
                  getValue(
                    item,
                    `release_date_location.release_date_audit_cycles.cycle`,
                    ""
                  )
                : "-",
            })
          )
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  const [modalAction, setModalAction] = useState<string>("");
  const [createModal, setModal] = useState(false);
  const toggleModal = (action = "", locationId: any, auditCycleId: any) => {
    setModalAction(action);
    setLocation_id(locationId);
    setAuditCycle_id(auditCycleId);
    setModal(!createModal);
  };

  const rowClick = (obj: object) => {};

  const [check, setCheck] = useState(false);
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {};
    }
    return {};
  };

  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const [location_id, setLocation_id] = useState();
  const [auditCycle_id, setAuditCycle_id] = useState();

  const columns = React.useMemo(
    () => [
      {
        Header: "Site name",
        accessor: "location_name",
        style: { "white-space": "unset", overflow: "hidden" },
        width: 220,
      },
      {
        Header: "Account Name",
        accessor: "group_name",
      },
      {
        Header: "Recent Release Dates",
        accessor: "recent_release_dates",
        width: 200,
      },
      {
        Header: "Release Cycle",
        accessor: "release_cycle",
      },
      {
        Header: "Created At",
        accessor: "created_at",
        width: 200,
      },
      {
        Header: "Action",
        accessor: "action",
        style: { "white-space": "unset" },
        width: 300,
        Cell: ({ row }: any) => {
          return (
            <>
              <div className="vendor-action-wrapper">
                {/* <NavLink to={`/repository/checkpoint/release-dates-new/vendor-history/${getValue(row, `original.release_date_location.id`, "")}`} className="btn btn-primary-outline me-2">History</NavLink> */}
                <button
                  className="btn btn-primary-outline me-2"
                  onClick={() =>
                    toggleModal(
                      "create",
                      getValue(row, `original.id`, ""),
                      getValue(
                        row,
                        `original.release_date_location.release_date_audit_cycles.id`,
                        ""
                      )
                    )
                  }
                >
                  Create New
                </button>

                {getValue(row, `original.release_date_location.id`, "") && (
                  <button
                    className="btn btn-primary-outline me-2"
                    onClick={() =>
                      toggleModal(
                        "edit",
                        getValue(row, `original.id`, ""),
                        getValue(
                          row,
                          `original.release_date_location.release_date_audit_cycles.id`,
                          ""
                        )
                      )
                    }
                  >
                    Edit
                  </button>
                )}

                {getValue(row, `original.release_date_location.id`, "") && (
                  <NavLink
                    to={`/repository/checkpoint/release-dates-new/vendor-history/${getValue(
                      row,
                      `original.release_date_location.id`,
                      ""
                    )}`}
                    className="btn btn-primary-outline me-2"
                  >
                    History
                  </NavLink>
                )}
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: number) => {
    setPage_no(page_no);
    getData(page_no, limit);
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let payload = {
    //   ...params,
    //   page_no: page_no,
    // };
    // let queryRequest = QueryRequestHelper(payload);
    // navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: number) => {
    setLimit(limit);
    getData(page_no, limit);
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let payload: any = {
    //   ...params,
    //   limit: limit,
    //   page_no: "1",
    // };
    // let queryRequest = QueryRequestHelper(payload);
    // navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Checkbox Section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIndex, setSelectedIndex] = useState<any>([]);

  const handleChangeCheckbox = (id: String) => {
    let selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    } else {
      let selected = selectedIndex.filter((item: string) => item !== id);
      setSelectedIndex(selected);
    }
  };
  const handleAddCheckbox = (id: String) => {
    let selected = selectedIndex.filter((item: string) => item === id);
    if (getValue(selected, `length`, 0) === 0) {
      selectedIndex.push(id);
      setSelectedIndex([...selectedIndex]);
    }
  };

  const tomorrowDate: any = moment().add(1, "days");
  let tomorrow: any = new Date(tomorrowDate);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmModal = () => {
    setConfirmOpen(!confirmOpen);
  };
  const handleAuditCompleteConfirm = () => {
    handleConfirmModal();
  };

  // const handleAuditComplete = async () => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let dates = date ? date : new Date();
  //   let month = params.date
  //     ? params.date.split("-")[1]
  //     : date
  //     ? moment(date).format("MM")
  //     : moment(dates).format("MM");
  //   let year = params.date
  //     ? params.date.split("-")[0]
  //     : date
  //     ? moment(date).format("YYYY")
  //     : moment(dates).format("YYYY");

  //   const payload = list.filter((f: object) =>
  //     selectedIDs.some((d: string) => d === getValue(f, `id`, ""))
  //   );

  //   let payloadObj = JSON.parse(JSON.stringify(payload));

  //   const locationId = getValue(
  //     payloadObj[0],
  //     "release_date_location.location.id",
  //     ""
  //   );
  //   const vendorId = getValue(payloadObj[0], "vendor_id", "");

  //   let bulkUploadPayload = {
  //     month: month,
  //     year: year,
  //   };

  //   console.log(payloadObj, "===payloadObj==>")

  //   let singleUploadPayload = {
  //     month: month,
  //     year: year,
  //     vendor_id: vendorId,
  //     // location_id: locationId,
  //     ...(locationId && { location_id: locationId }),
  //   };

  //   payloadObj.forEach((item:any) => {
  //     // Check if recent_release_dates is empty, missing, or "-"
  //     if (!item.recent_release_dates || item.recent_release_dates.trim() === "" || item.recent_release_dates === "-") {
  //         alert("recent_release_dates is empty, missing, or invalid ('-')");
  //         return; // End the current iteration for this item
  //     }
  //   });

  //   try {
  //     // if(getValue(payloadObj, `recent_release_dates`, "")) {
  //     //   alert(getValue(payloadObj, `recent_release_dates`, ""))
  //     // } else {
  //     //   alert("not available")
  //     // }

  //     if (selectedIDs.length > 1) {
  //       let resp = await ReleaseVendorAuditCompleteBulkUpload(
  //         bulkUploadPayload
  //       );
  //       if (resp) {
  //         toast.success(getValue(resp, `message`, ""));
  //         getData(page_no, limit);
  //         handleConfirmModal();
  //       }
  //     } else {
  //       let resp = await ReleaseVendorAuditCompleteUpload(singleUploadPayload);
  //       if (resp) {
  //         toast.success(getValue(resp, `message`, ""));
  //         getData(page_no, limit);
  //         handleConfirmModal();
  //       }
  //     }
  //   } catch (error) {}
  // };

  const handleAuditComplete = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let month = params.date
      ? params.date.split("-")[1]
      : date
      ? moment(date).format("MM")
      : moment(dates).format("MM");
    let year = params.date
      ? params.date.split("-")[0]
      : date
      ? moment(date).format("YYYY")
      : moment(dates).format("YYYY");

    const payload = list.filter((f: object) =>
      selectedIDs.some((d: string) => d === getValue(f, `id`, ""))
    );

    let payloadObj = JSON.parse(JSON.stringify(payload));

    // Check for errors in recent_release_dates first
    const hasEmptyReleaseDates = payloadObj.some(
      (item: any) =>
        !item.recent_release_dates ||
        item.recent_release_dates.trim() === "" ||
        item.recent_release_dates === "-"
    );

    if (hasEmptyReleaseDates) {
      toast.error("Release Dates is empty or missing");
      getData(page_no, limit);
      setSelectedIDs([]);
      handleConfirmModal();
      return; // Add return to stop execution
    } else {
      const locationId = getValue(
        payloadObj[0],
        "release_date_location.location.id",
        ""
      );
      const vendorId = getValue(payloadObj[0], "vendor_id", "");

      let bulkUploadPayload = {
        month: month,
        year: year,
      };

      let singleUploadPayload = {
        month: month,
        year: year,
        vendor_id: vendorId,
        ...(locationId && { location_id: locationId }),
      };

      let newPayload = {
        month: month,
        year: year,
        is_bulk: true,
        vendor_id: [
          {
            id: vendorId,
            location_id: selectedIDs,
          },
        ],
      };
      // console.log(newPayload)
      try {
        // if (selectedIDs.length > 1) {
        let resp = await ReleaseVendorAuditCompleteBulkUpload(
          newPayload
        );
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          getData(page_no, limit);
          handleConfirmModal();
          setSelectedIDs([]);
        }
        // } else {
        //   let resp = await ReleaseVendorAuditCompleteUpload(singleUploadPayload);
        //   if (resp) {
        //     toast.success(getValue(resp, `message`, ""));
        //     getData(page_no, limit);
        //     handleConfirmModal();
        //     setSelectedIDs([]);
        //   }
        // }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      {selectedIDs.length > 0 && (
        <ReleaseCustomNavigationBar
          selectedIndex={selectedIDs}
          permissions={"update"}
          handleAuditCompleteConfirm={handleAuditCompleteConfirm}
          handleRemoveNavItems={handleRemoveNavItems}
        />
      )}
      <CreateModal
        isOpen={createModal}
        toggle={toggleModal}
        vendor_id={getValue(props, `vendorId`, "")}
        location_id={location_id}
        action={modalAction}
        auditCycle_id={auditCycle_id}
        getData={() => getData(page_no, limit)} // Pass a function reference
        />

      {isLoading ? (
        <Loader />
      ) : list.length > 0 ? (
        <div className="only-bottom-borders release-date-vendor-table">
          <ScrollableReactTable
            columns={columns}
            data={list}
            getTableState={getTableState}
            rowClick={rowClick}
            check={check}
            // checkboxlogo
            selectedIDs={selectedIDs}
            getTrProps={getTrProps}
          />
        </div>
      ) : (
        <>
          {Object.keys(params).length !== 0 ? (
            <>
              <div className="alert alert-info mb-0">
                No Sites Mapped with this vendor
              </div>
            </>
          ) : (
            <>
              <div className="alert alert-info mb-0">
                No Sites Mapped with this vendor
              </div>
            </>
          )}
        </>
      )}
      {/* <div className="only-bottom-borders release-date-vendor-table">
        <ScrollableReactTable
          columns={columns}
          data={list}
          getTableState={getTableState}
          rowClick={rowClick}
          check={check}
          checkboxlogo
          selectedIDs={selectedIDs}
          getTrProps={getTrProps}
        />
      </div> */}
      {list.length > 0 ? (
        <>
          {totalCount > limit ? (
            <PaginationPage
              totalCount={totalCount}
              limit={limit}
              pageNumber={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            <div className="footer-wrapper d-flex">
              Total Count:&nbsp;&nbsp;{" "}
              <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
            </div>
          )}
        </>
      ) : (
        <> </>
      )}

      <ConfirmModal
        isOpen={confirmOpen}
        handleModal={handleConfirmModal}
        handleSubmit={handleAuditComplete}
      />
    </>
  );
}

// export default VendorTable;
